import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import { StaticQuery, graphql } from 'gatsby';

const Image = ({ src, alt, className }) => {
  const renderImage = file => (
    <Img
      fluid={file.node.childImageSharp.fluid}
      alt={alt}
      className={className}
    />
  );

  return (
    <StaticQuery
      query={graphql`
        query {
          images: allFile(
            filter: { extension: { regex: "/jpeg|jpg|png|gif/" } }
          ) {
            edges {
              node {
                extension
                relativePath
                childImageSharp {
                  fluid(maxWidth: 1000) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      `}
      render={({ images }) => {
        const imageFile = images.edges.find(
          image => image.node.relativePath === src
        );
        if (!imageFile) {
          return null;
        }

        return renderImage(imageFile);
      }}
    />
  );
};

Image.defaultProps = {
  className: '',
  alt: '',
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
};

export default Image;
